import React from "react";

const DataKLG = () => {
  return (
    <div style={{ width: "100%", height: "600px" }}>
      <iframe
        title="Data Penumpang Kartu Layanan Gratis"
        src="https://lookerstudio.google.com/embed/reporting/fe9cbf47-35cb-4a4d-9f72-857e3c1943b4/page/VpseF"
        width="100%"
        height="100%"
        style={{
          border: 0,
          overflow: "hidden",
        }}
        allowFullScreen
      ></iframe>
    </div>
  );
};

export default DataKLG;
